<template>
  <div >
    <div v-if="isScrolled9">
      <Header1 />
    </div>
    <div class="info-banner about-banner">
      <div class="img"><img src="../assets/img/t12.png" alt=""></div>
      <div class="tbox">
        <div class="timg"><img src="../assets/img/t13.png" alt=""> </div>
        <div class="ttbox">
          <h1 class="t1">{{techIntro.typename}}</h1>
          <!-- <div class="t2"></div> -->
        </div>
      </div>
    </div>

<!--    动画三栏-->
    <div class="skill-box1">
      <div class="box">
        <div class="list">
          <ul>

<!--            一栏·-->
            <li  class="move1" :class="{ animated: showAnimation }" >
              <div class="tbox wow fadeInUp">
                <h3 class="t1">{{techIntro.archiveList[0].title}}</h3>
                <!--                                <div class="t2"><p>ZHL超压缩技术主要基于多种独立算法，致力保障原始文件的完整性，其中每种算法都作为数据压缩的特定数学设计框架。无论文件的格式如何，每个算法可以接收二进制数据（即文件作为输入），对其内容进行重组，并将高度可压缩的文件保存为输出。原始文件（输入文件）的所有内容都可以通过与其重组的相同算法来检索。算法本身并不压缩数据，它们以输出文件高度可压缩的方式智能地改变数据结构。另外压缩速度快，我们的压缩速度和其他压缩技术速度相比大约高出20%~60%。</p></div>-->
                <div class="t2">
                  <p v-html="techIntro.archiveList[0].content"></p>
                </div>
              </div>
              <!--                            <div class="img wow fadeInUp"  data-wow-delay="0.2s"><img src="../assets/img/t3.png" alt=""></div>-->
              <div class="img wow fadeInUp"  data-wow-delay="0.2s">
                <img :src="'https://www.yasubit.com/' + techIntro.archiveList[0].litpic" alt=""/>
              </div>
            </li>


<!--            二栏-->
            <li v-if="isScrolled"  class="move1" :class="{ animated: showAnimation1 }">
              <div class="tbox wow fadeInUp"  data-wow-delay="0.4s">
                <h3 class="t1">{{techIntro.archiveList[1].title}}</h3>
                <!--                                <div class="t2"><p>我们的无损压缩技术是真正做到了无损。经压缩后再解压缩的文件与源文件相比，我们会对比这两份文件的MD5值。当两个文件的MD5值相同时，才能确保这两份文件是完全相同的文件。<br/>-->
                <!--                                    对于一些对数据完整性高度重视的行业和场景，我们都会通过无损压缩的方式为客户解决存储和传输的问题。即在保证用户数据经压缩后仍然能完好无损保留的情况下，为用户节约存储资源，提高传输效率。</p></div>-->
                <div class="t2">
                  <p v-html="techIntro.archiveList[1].content"></p>
                </div>
              </div>
              <!--                            <div class="img wow fadeInUp"  data-wow-delay="0.6s"><img src="../assets/img/t4.png" alt=""></div>-->
              <div class="img wow fadeInUp"  data-wow-delay="0.2s">
                <img :src="'https://www.yasubit.com/' + techIntro.archiveList[1].litpic" alt=""/>
              </div>
            </li>

<!--            三栏-->
            <li v-if="isScrolled1" class="move1" :class="{ animated: showAnimation2 }">
              <div class="tbox wow fadeInUp"  data-wow-delay="0.8s">
                <h3 class="t1">{{techIntro.archiveList[2].title}}</h3>
                <!--                                <div class="t2"><p>针对多媒体数据如视频、音频、图像等。ZHL可以在不改变原有视觉或听觉质量（如视频分辨率和帧率、图像分辨率和音频质量等）情况下进行平均压缩率在10%~20%的压缩，如视频原始码流为4Mbps，通过我们进行压缩后仅以400~800kbps 的码流向后端进行传输和存储。</p></div>-->
                <div class="t2">
                  <p v-html="techIntro.archiveList[2].content"></p>
                </div>
              </div>
              <!--                            <div class="img wow fadeInUp"  data-wow-delay="1s"><img src="../assets/img/t5.png" alt=""></div>-->
              <div class="img wow fadeInUp"  data-wow-delay="0.2s">
                <img :src="'https://www.yasubit.com/' + techIntro.archiveList[2].litpic" alt=""/>
              </div>
            </li>
          </ul>



        </div>
      </div>
    </div>



<!--低压缩比表格-->
    <div v-if="isScrolled2" class="move1" :class="{ animated: showAnimation2 }" >
    <div  class="skill-box2">
      <div class="box">
        <div class="title">{{lowCompress.typename}} <span></span></div>
        <div class="img wow fadeInUp">
          <img src="../assets/img/t6.png">
          <!--                    <img src="/uploads/allimg/20210507/1-21050G5534U25.png">-->
          <img :src="'https://www.yasubit.com/' + lowCompress.archiveList[0].litpic" alt=""/>
        </div>
        <div class="tips">
          <p v-html="lowCompress.archiveList[0].content"></p>
        </div>
      </div>
    </div>
    </div>

<!--支持多种文件-->
    <div v-if="isScrolled3" class="move1" :class="{ animated: showAnimation2 }" >
    <div class="skill-box3">
      <div class="box">
        <h2 class="title">{{styleList.typename}} <span></span></h2>
        <h4 class="txt">支持多种格式文件压缩</h4>
        <div class="list">
          <ul>
            <li v-for="(item,index) in styleList.archiveList" :key="index" class="wow fadeInUp">
              <div class="img">
                <img :src="'https://www.yasubit.com/' + item.litpic" alt=""/>
              </div>
              <div class="tbox">
                <h3 class="t1">{{item.title}}</h3>
                <div class="t2">{{item.describe}}</div>
              </div>
            </li>

          </ul>
        </div>
      </div>
    </div>
    </div>

    <Footer/>

  </div>
</template>
<script>
import Banner from "../components/Banner";
import Footer from "@/views/footer.vue";
import Header1 from "@/views/header1.vue";
export default {
  components: {
    Header1,
    Banner,
    Footer

  },

  created() {
    document.title = '技术介绍_智慧林';
    this.getList();
  },

  data() {
    return {
      isScrolled:false,
      isScrolled1:false,
      isScrolled2:false,
      isScrolled3:false,
      showAnimation: true,
      showAnimation1: false,
      showAnimation2: false,
      isScrolled9: true,
      data: undefined,
      techIntro: undefined,
      lowCompress: undefined,
      styleList: undefined,
    };
  },
  methods: {
    handleScroll1() {

      // 获取滚动条距离顶部的距离
      const scrollDistance =
          window.scrollY || document.documentElement.scrollTop;

      // 当滚动距离大于等于500px时，设置isScrolled为true
      this.isScrolled = scrollDistance >= 300;
      this.isScrolled1 = scrollDistance >= 900;
      this.isScrolled2 = scrollDistance >= 1300;
      this.isScrolled3 = scrollDistance >= 2500;
      // console.log("距离");
      // console.log(this.isScrolled);
    },
    handleScroll9() {

      // 获取当前滚动位置
      const scrollY = window.scrollY || window.pageYOffset;
      // 可以设置一个阈值来确定何时改变isScrolled9的值
      const dis = 100;

      // 判断滚动位置是否大于阈值
      if (scrollY > dis) {

        // 向下滚动，将isScrolled9设为false

        this.isScrolled9 = false;
      } else {

        // 向上滚动，将isScrolled9设为true

        this.isScrolled9 = true;




      }




      // const scrollDistance = window.scrollY || document.documentElement.scrollTop;

      // // 当滚动距离小于等于200px时，设置isScrolled9为true

      // this.isScrolled9 = scrollDistance <=500;


    },
    getList() {
      this.$http
          .get("/yasubit/website/3")
          .then((response) => {
            this.data = response.data.data[0].children;
            console.log(this.data)
            this.parse();
          })
          .catch((error) => {
            this.$message.error(error);
          });
    },

    parse() {
      // 技术介绍
      this.techIntro = this.data.find(item => item.id === 23);
      console.log( this.techIntro)
      // 低压缩比
      this.lowCompress = this.data.find(item => item.id === 25);
      // 支持多种格式文件
      this.styleList = this.data.find(item => item.id === 27);

      // console.log(this.aa)
      // console.log(this.aa.archiveList[0])
      // console.log(this.aa.archiveList[1])
      // console.log(this.aa.archiveList[2])
      // console.log(this.aa.archiveList[2])
      // console.log("-------***********-----")
      // console.log(this.bb)
      // console.log(this.cc)
    },

  },




  // data() {
  //     return {
  //         loading: true,
  //         caseList: []
  //     };
  // },
  mounted() {
    // 监听滚动事件
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("scroll", this.handleScroll9);
    window.addEventListener("scroll", this.handleScroll1);
    // 初始化时检查滚动位置
    this.handleScroll();

    this.getchData();


  },
};
</script>

<style lang="scss" scoped>

.move1 {
  opacity: 0; // 初始时透明度为0，隐藏元素
  animation: fadeIn 1s forwards, moveUp 1.5s forwards; // 1s 表示动画持续时间，forwards 表示动画结束后保持最终状态
}

.move2 {
  opacity: 0; // 初始时透明度为0，隐藏元素
  animation: fadeIn 2s forwards, moveUp 1s forwards; // 1s 表示动画持续时间，forwards 表示动画结束后保持最终状态
}

.move3 {
  opacity: 0; // 初始时透明度为0，隐藏元素
  animation: fadeIn 3s forwards, moveUp 0.5s forwards; // 1s 表示动画持续时间，forwards 表示动画结束后保持最终状态
}

.move4 {
  opacity: 0; // 初始时透明度为0，隐藏元素
  animation: fadeIn 4s forwards, moveUp 1s forwards; // 1s 表示动画持续时间，forwards 表示动画结束后保持最终状态
}

.move5 {
  opacity: 0; // 初始时透明度为0，隐藏元素
  animation: fadeIn 4.5s forwards, moveUp 1.5s forwards; // 1s 表示动画持续时间，forwards 表示动画结束后保持最终状态
}

.move6 {
  opacity: 0; // 初始时透明度为0，隐藏元素
  animation: fadeIn 5s forwards, moveUp 2.5s forwards; // 1s 表示动画持续时间，forwards 表示动画结束后保持最终状态
}

@keyframes moveUp {
  to {
    transform: translateY(-30px); // 向上移动 px
  }
}

@keyframes fadeIn {
  to {
    opacity: 1; // 最终透明度为1，显示元素
  }
}

#movingBox {
  transition: transform 0.5s ease; // 添加过渡效果
}

.bounce-animation {
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0); // 初始位置和结束位置
  }

  40% {
    transform: translateY(-15px); // 上抬的高度，可以根据需要修改
  }

  60% {
    transform: translateY(-15px); // 下压的高度，可以根据需要修改
  }
}










.between{

  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.center{
  display: flex;align-items: center; text-align: center;justify-content: center
}
.one-third{
  width: 33.333333%;
  height: 50px;
  background-color: pink;
}
.one-five{
  display: flex;align-items: center; text-align: center;justify-content: center;flex-direction: column;
  width: 20%;
  height: 50px;

}

.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-image: url('../../src/assets/img/t1.png'); /* 替换 'your-image.jpg' 为你的背景图片路径 */
  //background-size: auto 50%; /* 背景图片宽度自适应，高度占据50% */
  background-repeat: no-repeat;


  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>
